import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { getPropertyLabel, getReferenceLabel } from 'reporting-data/v2/dataset/datasetTypes';
import { CustomHighchartsTooltip, TooltipBody, TooltipBodyLabel, TooltipBodyListContainer, TooltipBodyValue, TooltipHeader } from 'reporting-visualizations/highcharts/options/customTooltipStyles';
import { FIELDS } from '../constants/fields';
import { renderToString } from 'react-dom/server';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapDataToNodes = ({
  dataset,
  filterProperty
}) => dataset.data.reduce((map, dataRecord) => Object.assign({}, map, {
  [dataRecord[filterProperty]]: dataRecord
}), {});
export const renderTooltipInfo = ({
  point,
  linksDataMap
}) => {
  const {
    id,
    options: {
      isNode,
      from,
      to
    },
    linksTo
  } = point;
  const dataRecords = isNode ? linksTo.map(incomingLinkPoint => linksDataMap[incomingLinkPoint.from][id]) : [linksDataMap[from][to]];
  const hasAnonymousVisitors = dataRecords.filter(record => record[FIELDS.CONTAINS_ANONYMOUS_VISITORS] === 'true').length > 0;
  return hasAnonymousVisitors ? /*#__PURE__*/_jsxs("div", {
    style: {
      whiteSpace: 'normal',
      minWidth: '250px'
    },
    children: [/*#__PURE__*/_jsx("br", {}), I18n.text('reporting-snowflake.funnel.anonymous-visitors-tooltip')]
  }) : null;
};

//Note: This utility can only be used for vertical/horizontal funnel journeys
//This utility directly utliizes dataset manipulations based on the assumptions
//that there would no branching records within the dataset.
const getFunnelTooltip = ({
  dataset,
  filterProperty,
  valueProperty
}) => {
  const nodeDatamap = mapDataToNodes({
    dataset,
    filterProperty
  });
  return function () {
    let tooltip = null;
    const {
      category
    } = this.point;
    const properties = dataset.properties;
    const categoryReferences = properties[filterProperty]['references'];
    const nodeId = Object.keys(categoryReferences).find(key => categoryReferences[key]['label'] === category);
    const dataBucket = nodeId && nodeDatamap[nodeId];
    const hasAnonymousVisitors = dataBucket && dataBucket[FIELDS.CONTAINS_ANONYMOUS_VISITORS] === 'true';
    const propertyLabel = getPropertyLabel(dataset, valueProperty);
    const valueLabel = dataBucket && getReferenceLabel(dataset, valueProperty, dataBucket[valueProperty]);
    const additionalInfo = hasAnonymousVisitors ? /*#__PURE__*/_jsxs(View, {
      minInlineSize: "250px",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
        as: "small",
        textWrap: "wrap",
        children: I18n.text('reporting-snowflake.funnel.anonymous-visitors-tooltip')
      })]
    }) : null;
    tooltip = /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
      children: [/*#__PURE__*/_jsx(TooltipHeader, {
        children: category
      }), /*#__PURE__*/_jsxs(TooltipBody, {
        children: [/*#__PURE__*/_jsxs(TooltipBodyListContainer, {
          children: [/*#__PURE__*/_jsx(TooltipBodyLabel, {
            children: hasAnonymousVisitors ? `${propertyLabel}*` : propertyLabel
          }), /*#__PURE__*/_jsx(TooltipBodyValue, {
            children: valueLabel
          })]
        }, valueProperty), additionalInfo]
      })]
    });
    return renderToString(tooltip);
  };
};
export const getFunnelTooltipFormatter = ({
  report,
  dataset,
  filterProperty,
  valueProperty
}) => {
  if (report.journeyQuery.allowAnonymousVisitors) return getFunnelTooltip({
    dataset,
    filterProperty,
    valueProperty
  });
  return undefined;
};